import z from 'zod';

type CoerceFn = (v: unknown) => unknown;

const defaultCoerce: CoerceFn = v => v;

const toArray = (v: unknown): unknown[] => {
	if (v == null || v === '') return [];

	if (Array.isArray(v)) return v;

	return [ v ];
};

const firstOrUndef = (v: unknown): unknown => {
	if (Array.isArray(v)) return v[0] ?? undefined;

	return v ?? undefined;
};

export const createSingleSelectSchema = <T extends z.ZodTypeAny>(
	item: T,
	msg = 'Required',
	coerce: CoerceFn = defaultCoerce,
) =>
	z.preprocess(v => coerce(firstOrUndef(v)), item.refine(() => true, msg));

export const createOptionalSingleSelectSchema = <T extends z.ZodTypeAny>(
	item: T,
	coerce: CoerceFn = defaultCoerce,
) =>
	z.preprocess(v => coerce(firstOrUndef(v)), item.optional());

export const createMultiSelectSchema = <T extends z.ZodTypeAny>(
	item: T,
	msg = 'Required',
	coerce: CoerceFn = defaultCoerce,
) =>
	z.preprocess(
		v => toArray(v).map(coerce).filter(x => x != null && x !== ''),
		z.array(item).min(1, msg),
	);

export const createOptionalMultiSelectSchema = <T extends z.ZodTypeAny>(
	item: T,
	coerce: CoerceFn = defaultCoerce,
) =>
	z.preprocess(
		(v) => {
			const arr = toArray(v).map(coerce).filter(x => x != null && x !== '');

			return arr.length ? arr : undefined;
		},
		z.array(item).optional(),
	);
